module.exports = __webpack_public_path__ + "static/media/program_step_1_fr.e49c6a6b.svg";